/**
 * Helper
 */
var helper = require('../../helper'),
        dataTables_buttons = [

            {
                extend: 'csv',
                text: 'Export as CSV',
                exportOptions: {
                    columns: [0, 1, 2, 3, 4, 5, 6, 7, 8]
                },
                className: 'btn btn-default'
            },
            {
                extend: 'pdf',
                text: 'Export as PDF',
                exportOptions: {
                    columns: [0, 1, 2, 3, 4, 5, 6, 7, 8]
                },
                className: 'btn btn-default',
                orientation: 'landscape'
            },
            {
                extend: 'colvis',
                className: 'btn btn-default'
                //     columns: ':gt(0)'
            }


        ];


$(function() {
    var $datatable = $('#datatable-property-viewing-report'),
        $dt;

 //   console.log('viewing report!');

    $dt = $datatable.DataTable({
        "dom": "<'dt-toolbar'lfB>tr<'row'<'col-sm-5'i><'col-sm-7'p>>",
        "buttons": dataTables_buttons,
        "processing": true,
        "serverSide": true,
        "responsive": true,
        "lengthMenu": [[ 30, 10, 25, 50, 75, 100], [ 30, 10, 25, 50, 75, 100]],
        //"ajax": helper.getOrigin() + "/api/property_viewings/report",
        "ajax": {
            url: helper.getOrigin() + "/api/property_viewings/report",
            data: function (d) {
                d.viewingsCount_operator = $('select[name=viewingsCount_operator]').val();
                d.viewingsCount = $('input[name=viewingsCount]').val();
                d.viewingsTaken_operator = $('select[name=viewingsTaken_operator]').val();
                d.viewingsTaken = $('input[name=viewingsTaken]').val();
                d.viewingsAttendees_operator = $('select[name=viewingsAttendees_operator]').val();
                d.viewingsAttendees = $('input[name=viewingsAttendees]').val();
                d.userId = $('select[name=user_id]').val();
                d.date = $('input[name=date]').val();
                d.dateTo = $('input[name=date_to]').val();
            }
        },
        "autoWidth" : false,
        "order": [[ 0, "asc" ]],
        "columns": [
            {data: 'fullName', name: 'fullName'},
            {data: 'propertyName', name: 'propertyName'},
            {data: 'property_id', name: 'properties.property_id'},
            {data: 'postcode', name: 'properties.postcode'},
            {data: 'viewingsCount', name: 'viewingsCount', searchable: false},
            {data: 'viewingsAttendees', name: 'viewingsAttendees', searchable: false},
            {data: 'vacant', name: 'vacant', searchable: false, orderable: false},
            {data: 'viewingsTaken', name: 'viewingsTaken', searchable: false},
            {data: 'reduction', name: 'reduction', searchable: false, orderable: false},
        ],
        "initComplete": function(settings, json) {
            // init callback
        }
    });

    $('#search-form').on('submit', function(e) {
        $dt.draw();
        e.preventDefault();
    });

});
